import React from 'react';
import { Container, Row, Col, Card, Button, ListGroup, Image, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaTrash, FaArrowLeft, FaHeart, FaShoppingCart, FaEye } from 'react-icons/fa';
import Layout from '../components/layout/Layout';
import { useWishlist } from '../contexts/WishlistContext';
import { useCart } from '../contexts/CartContext';

const Wishlist = () => {
  const { wishlistItems, removeFromWishlist, clearWishlist } = useWishlist();
  const { addToCart } = useCart();
  
  const handleRemoveItem = (productId) => {
    removeFromWishlist(productId);
  };
  
  const handleAddToCart = (product) => {
    addToCart(product);
    removeFromWishlist(product.id);
  };
  
  return (
    <Layout>
      <Container className="py-4">
        <h2 className="mb-4">
          <FaHeart className="me-2 text-danger" />
          Your Wishlist
        </h2>
        
        {wishlistItems.length === 0 ? (
          <Card className="text-center p-5 shadow-sm">
            <Card.Body>
              <h3>Your wishlist is empty</h3>
              <p className="text-muted">
                Save items you like by clicking the heart icon on product pages.
              </p>
              <Button 
                as={Link} 
                to="/products" 
                variant="primary"
                size="lg"
                className="mt-3"
              >
                <FaArrowLeft className="me-2" />
                Browse Products
              </Button>
            </Card.Body>
          </Card>
        ) : (
          <Card className="shadow-sm">
            <Card.Body>
              <Row className="mb-3">
                <Col>
                  <h5>{wishlistItems.length} {wishlistItems.length === 1 ? 'item' : 'items'} in your wishlist</h5>
                </Col>
                <Col className="text-end">
                  <Button 
                    variant="outline-danger"
                    size="sm"
                    onClick={() => clearWishlist()}
                  >
                    <FaTrash className="me-2" />
                    Clear Wishlist
                  </Button>
                </Col>
              </Row>
              
              <ListGroup variant="flush">
                {wishlistItems.map(item => (
                  <ListGroup.Item key={item.id} className="py-3">
                    <Row className="align-items-center">
                      <Col xs={3} md={2}>
                        <Image 
                          src={item.images[0]} 
                          alt={item.name} 
                          fluid 
                          thumbnail
                        />
                      </Col>
                      <Col xs={9} md={5}>
                        <h5>
                          <Link to={`/products/${item.id}`} className="text-decoration-none">
                            {item.name}
                          </Link>
                        </h5>
                        <div className="text-muted small mb-1">
                          Seller: {item.seller?.name || 'Unknown'}
                        </div>
                        <div className="d-flex align-items-center">
                          <span className="text-primary me-2">
                            GH₵ {item.price.toFixed(2)}
                          </span>
                          <Badge bg="success">{item.status}</Badge>
                        </div>
                      </Col>
                      <Col md={5} className="mt-3 mt-md-0 text-end">
                        <div className="d-flex flex-column flex-md-row justify-content-end gap-2">
                          <Button 
                            variant="outline-primary" 
                            size="sm"
                            as={Link}
                            to={`/products/${item.id}`}
                          >
                            <FaEye className="me-1" /> View
                          </Button>
                          <Button 
                            variant="outline-success" 
                            size="sm"
                            onClick={() => handleAddToCart(item)}
                          >
                            <FaShoppingCart className="me-1" /> Add to Cart
                          </Button>
                          <Button 
                            variant="outline-danger" 
                            size="sm"
                            onClick={() => handleRemoveItem(item.id)}
                          >
                            <FaTrash className="me-1" /> Remove
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </Card.Body>
            <Card.Footer className="bg-white">
              <Button 
                as={Link} 
                to="/products" 
                variant="outline-primary"
              >
                <FaArrowLeft className="me-2" />
                Continue Shopping
              </Button>
            </Card.Footer>
          </Card>
        )}
        
        {/* Recommended Products */}
        {wishlistItems.length > 0 && (
          <div className="mt-5">
            <h3 className="mb-4">You might also like</h3>
            <Row>
              {[1, 2, 3].map(i => (
                <Col md={4} key={i} className="mb-4">
                  <Card className="h-100 product-card">
                    <Card.Img 
                      variant="top" 
                      src={`https://via.placeholder.com/300x200?text=Recommended+${i}`}
                      alt={`Recommended Product ${i}`}
                    />
                    <Card.Body>
                      <Card.Title>Recommended Product {i}</Card.Title>
                      <Card.Text className="text-truncate">
                        This is a recommended product based on your wishlist items.
                      </Card.Text>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="fw-bold">GH₵ {(Math.random() * 50 + 10).toFixed(2)}</span>
                        <Badge bg="success">available</Badge>
                      </div>
                    </Card.Body>
                    <Card.Footer className="bg-white">
                      <div className="d-flex justify-content-between">
                        <Button 
                          variant="outline-primary" 
                          size="sm"
                          as={Link}
                          to={`/product/${i + 100}`}
                        >
                          <FaEye className="me-1" /> View
                        </Button>
                        <div>
                          <Button 
                            variant="outline-danger" 
                            size="sm"
                            className="me-2"
                          >
                            <FaHeart />
                          </Button>
                          <Button 
                            variant="outline-success" 
                            size="sm"
                          >
                            <FaShoppingCart />
                          </Button>
                        </div>
                      </div>
                    </Card.Footer>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        )}
      </Container>
    </Layout>
  );
};

export default Wishlist;
